var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70834 0.502981C8.63542 0.499672 10.5677 0.496354 12.4948 0.493045C13.0729 0.492052 13.4696 0.970537 13.3403 1.51243C13.2627 1.83548 13.0547 2.04417 12.7268 2.12806C12.6226 2.15428 12.5081 2.15969 12.3987 2.15988C8.60703 2.16639 4.81017 2.17291 1.01851 2.17942C0.8883 2.17964 0.758073 2.16945 0.63301 2.1332C0.263032 2.02446 0.0123601 1.63427 0.0637994 1.25918C0.115176 0.847635 0.432357 0.539798 0.838571 0.518267C0.96877 0.512835 1.09899 0.51782 1.22919 0.517596C3.05731 0.509249 4.88022 0.50612 6.70834 0.502981Z",
    fill: "#6D7F8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71829 6.32062C5.3485 6.32297 3.97871 6.32532 2.60892 6.32767C2.07767 6.32859 1.70202 5.94902 1.73241 5.44897C1.75253 5.03748 2.0853 4.70357 2.4967 4.67162C2.54878 4.66632 2.60086 4.66623 2.65294 4.66614C5.36648 4.66148 8.08001 4.65682 10.7935 4.65216C11.3092 4.65127 11.6743 4.95273 11.7115 5.411C11.7488 5.90052 11.3797 6.3022 10.8745 6.30306C10.0151 6.30975 9.16097 6.30601 8.30159 6.30748C7.77036 6.31881 7.24433 6.31972 6.71829 6.32062Z",
    fill: "#6D7F8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70998 10.4819C5.88707 10.4834 5.05896 10.49 4.23603 10.4862C3.8402 10.4869 3.51161 10.2166 3.42244 9.85217C3.33326 9.47732 3.50446 9.0864 3.85835 8.92434C3.98845 8.86161 4.14465 8.8301 4.29048 8.82985C5.91547 8.82185 7.54046 8.81906 9.16546 8.81627C9.68629 8.81537 10.0515 9.16371 10.0523 9.64808C10.0531 10.1325 9.68914 10.4768 9.16832 10.4829C8.34539 10.4791 7.52769 10.4805 6.70998 10.4819Z",
    fill: "#6D7F8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrags);
export default __webpack_public_path__ + "static/media/drags.8e1e7ac424c486231c226f2138761b13.svg";
export { ForwardRef as ReactComponent };